import { SelectionLike } from './types';

export const parseSelection = (searchParams: URLSearchParams): SelectionLike | null => {
    // @TODO add validation
    try {
        return JSON.parse(searchParams.get('s') || '{}');
    } catch (e) {
        // @TODO handle errors
        // eslint-disable-next-line no-console
        console.error(e);
    }
    return null;
};
